(() => {
  const root = document.documentElement;
  let gtmLoaded = false;
  let metaLoaded = false;
  let reloadPending = false;
  function appendScript(id, src) {
    const script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }
  function syncConsent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return;
    const consent = privacy.currentVisitorConsent();
    const analytics = consent.analytics === 'yes' && privacy.analyticsProcessingAllowed();
    const marketing = consent.marketing === 'yes' && privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    const allowGtm = analytics && marketing;
    root.dataset.fioritAnalyticsConsent = analytics ? 'granted' : 'denied';
    root.dataset.fioritMarketingConsent = marketing ? 'granted' : 'denied';
    if ((gtmLoaded && !allowGtm) || (metaLoaded && !marketing)) {
      if (window.fbq) window.fbq('consent', 'revoke');
      if (!reloadPending) {
        reloadPending = true;
        window.location.reload();
      }
      return;
    }
    if (allowGtm && !gtmLoaded) {
      gtmLoaded = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
      appendScript('fiorit-consented-gtm', 'https://www.googletagmanager.com/gtm.js?id=GTM-MZPDDKZ');
    }
    if (marketing && !metaLoaded) {
      metaLoaded = true;
      if (!window.fbq) {
        const fbq = function() {
          if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
          else fbq.queue.push(arguments);
        };
        window.fbq = fbq;
        window._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        appendScript('fiorit-consented-meta', 'https://connect.facebook.net/en_US/fbevents.js');
      }
      window.fbq('consent', 'grant');
      window.fbq('init', '308710954633223');
      window.fbq('track', 'PageView');
    }
  }
  function start() {
    root.dataset.fioritAnalyticsConsent = 'denied';
    root.dataset.fioritMarketingConsent = 'denied';
    if (window.Shopify && window.Shopify.customerPrivacy) {
      syncConsent();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (!error) syncConsent();
      });
    }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();